/**
 * EventCarousel
 *
 * Navigation controls for the modal carousel.
 * Features: prev/next arrows and dot indicators with overview dot.
 */

import React from 'react';
import { Icon } from 'semantic-ui-react';

const EventCarousel = ({
  currentIndex,
  totalSlides,
  onPrev,
  onNext,
  onDotClick,
  hideDots = false,
}) => {
  // Don't show navigation if only 1 slide
  if (totalSlides <= 1) return null;

  // Generate dots - first is overview (wider), rest are events
  const dots = Array.from({ length: totalSlides }, (_, i) => i);

  return (
    <>
      {/* Arrow navigation */}
      <nav className="event-carousel-nav" aria-label="Event navigation">
        <button
          className="carousel-nav-button"
          onClick={onPrev}
          aria-label="Previous event (Left arrow)"
          title="Previous event (Left arrow)"
        >
          <Icon name="chevron left" />
        </button>

        <button
          className="carousel-nav-button"
          onClick={onNext}
          aria-label="Next event (Right arrow)"
          title="Next event (Right arrow)"
        >
          <Icon name="chevron right" />
        </button>
      </nav>

      {/* Dot indicators (can be hidden when rendered externally) */}
      {!hideDots && (
        <div className="carousel-dots" role="tablist" aria-label="Carousel navigation">
          {dots.map((dotIndex) => (
            <button
              key={dotIndex}
              className={`carousel-dot ${dotIndex === 0 ? 'overview-dot' : ''} ${currentIndex === dotIndex ? 'active' : ''}`}
              onClick={() => onDotClick(dotIndex)}
              role="tab"
              aria-selected={currentIndex === dotIndex}
              aria-label={dotIndex === 0 ? 'Calendar overview' : `Event ${dotIndex}`}
              title={dotIndex === 0 ? 'Calendar overview' : `Event ${dotIndex}`}
            />
          ))}
        </div>
      )}
    </>
  );
};

export default EventCarousel;
